/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Editor_WebsiteInputs */

const en_resume_editor_website = /** @type {(inputs: Resume_Editor_WebsiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Website`)
};

const de_resume_editor_website = /** @type {(inputs: Resume_Editor_WebsiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Webseite`)
};

const fr_resume_editor_website = /** @type {(inputs: Resume_Editor_WebsiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Site web`)
};

const es_resume_editor_website = /** @type {(inputs: Resume_Editor_WebsiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sitio web`)
};

const it_resume_editor_website = /** @type {(inputs: Resume_Editor_WebsiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sito web`)
};

const nl_resume_editor_website = /** @type {(inputs: Resume_Editor_WebsiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Website`)
};

const pl_resume_editor_website = /** @type {(inputs: Resume_Editor_WebsiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strona internetowa`)
};

const fi_resume_editor_website = /** @type {(inputs: Resume_Editor_WebsiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkkosivusto`)
};

const da_resume_editor_website = /** @type {(inputs: Resume_Editor_WebsiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hjemmeside`)
};

const sv_resume_editor_website = /** @type {(inputs: Resume_Editor_WebsiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Webbplats`)
};

/**
* | output |
* | --- |
* | "Website" |
*
* @param {Resume_Editor_WebsiteInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resume_editor_website = /** @type {((inputs?: Resume_Editor_WebsiteInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Editor_WebsiteInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resume_editor_website(inputs)
	if (locale === "fr") return fr_resume_editor_website(inputs)
	if (locale === "es") return es_resume_editor_website(inputs)
	if (locale === "it") return it_resume_editor_website(inputs)
	if (locale === "nl") return nl_resume_editor_website(inputs)
	if (locale === "pl") return pl_resume_editor_website(inputs)
	if (locale === "fi") return fi_resume_editor_website(inputs)
	if (locale === "da") return da_resume_editor_website(inputs)
	if (locale === "sv") return sv_resume_editor_website(inputs)
	return en_resume_editor_website(inputs)
});